import PropTypes from "prop-types";
import { ClipboardList, Download, Upload } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CONFIG from "Config";
import {
  SidebarActionItem,
  SidebarNavItem,
  SidebarSection,
} from "components/sidebar/sections/SidebarNav";

const IMPORT_PERMISSIONS = [
  ACL_RELATIONSHIPS.dataJob.read,
  ACL_RELATIONSHIPS.dataJob.create,
  ACL_RELATIONSHIPS.importData.edit,
];

const DataSidebar = ({
  onImportData,
  onImportCaseData,
  onExportContacts,
  onExportTargets,
  onExportAuditLog,
}) => (
  <>
    <SidebarSection label="Jobs" icon={<ClipboardList />}>
      <SidebarNavItem
        to="/data"
        end
        permissions={[ACL_RELATIONSHIPS.dataJob.read]}
      >
        Data Jobs
      </SidebarNavItem>
    </SidebarSection>

    <SidebarSection label="Imports" icon={<Upload />}>
      <SidebarActionItem
        onClick={onImportData}
        permissions={IMPORT_PERMISSIONS}
      >
        Import Data
      </SidebarActionItem>
      <SidebarActionItem
        onClick={onImportCaseData}
        conditions={[CONFIG.ENABLE_PIRACY]}
        permissions={IMPORT_PERMISSIONS}
      >
        Import Case Data
      </SidebarActionItem>
      <SidebarNavItem
        to="/custom_tables/import"
        permissions={[ACL_RELATIONSHIPS.customTable.import]}
      >
        Import Custom Table
      </SidebarNavItem>
    </SidebarSection>

    <SidebarSection label="Exports" icon={<Download />}>
      <SidebarActionItem
        onClick={onExportContacts}
        permissions={[ACL_RELATIONSHIPS.exportContacts.create]}
      >
        Export Contacts
      </SidebarActionItem>
      <SidebarActionItem
        onClick={onExportTargets}
        permissions={[ACL_RELATIONSHIPS.exportTargets.create]}
      >
        Export Targets
      </SidebarActionItem>
      <SidebarActionItem
        onClick={onExportAuditLog}
        permissions={[ACL_RELATIONSHIPS.exportLogs.create]}
      >
        Export Audit Log
      </SidebarActionItem>
    </SidebarSection>
  </>
);

DataSidebar.propTypes = {
  onImportData: PropTypes.func.isRequired,
  onImportCaseData: PropTypes.func.isRequired,
  onExportContacts: PropTypes.func.isRequired,
  onExportTargets: PropTypes.func.isRequired,
  onExportAuditLog: PropTypes.func.isRequired,
};

export default DataSidebar;
